import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ModalService } from 'src/utils/modal.service';
import { ModalComponent } from "./components/modal/modal.component";
import { ToastService } from 'src/utils/toast.service';
import { ToastComponent } from "./components/toast/toast.component";
import { BaseModalComponent } from "./components/base-modal/base-modal.component";
import { MobileWarningService } from 'src/utils/mobile-warning.service';
import { TokenExpirationMonitorService } from 'src/core/services/auth/token-expiration-monitor.service';
import { AuthService } from 'src/core/services/auth/auth.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, ModalComponent, ToastComponent, BaseModalComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  public modalService = inject(ModalService);
  public toastService = inject(ToastService);
  private mobileWarningService = inject(MobileWarningService);
  private tokenMonitor = inject(TokenExpirationMonitorService);
  private authService = inject(AuthService);

  constructor() {}

  ngOnInit(): void {
    setTimeout(() => {
      this.mobileWarningService.showMobileWarningIfNeeded();
    }, 100);
    const isLoggedIn = this.authService.isLoggedIn();
    if (isLoggedIn) {
      this.tokenMonitor.startMonitoring();
    }
  }

  showToast(): void {
    this.toastService.showToast(
      'fi fi-ss-check-circle text-[24px] text-[#17BF33]',
      '¡Toast mostrado exitosamente!',
      'success'
    );
  }

  showModal(): void {
     this.modalService.showModal({
    title: '¡Tu cuenta está casi lista!',
    message: 'Completa la segmentación para activar todas las herramientas de PRECREDIT Advanced.',
    onConfirm: () => {},
    modalType: 'success',
    iconClass: 'fi fi-ss-check-circle text-4xl text-success',
    btnCancelar: false,
    continueButtonText: 'Continuar'
});
  }
  showModal2(): void {
  this.modalService.showModal({
    title: '¿Estás seguro de que deseas cerrar sesión?',
    message: '',
    onConfirm: () => {
    },
    modalType: 'confirmation',
    btnCancelar: true,
    cancelButtonText: 'Cancelar',
    continueButtonText: 'Cerrar sesión',
    iconClass: 'fi fi-sr-exclamation text-4xl text-error',
  });

  }
  showModal3(): void {
   this.modalService.showModal({
    title: '¿Deseas cancelar?',
    message: 'Solo faltan unos pasos para completar tu cuenta en PRECREDIT Advanced. Salir ahora dejará tu registro incompleto.',
    onConfirm: () => {
    },
    modalType: 'warning',
    iconClass: 'fi fi-sr-diamond-exclamation text-4xl text-error',

    btnCancelar: true,
    cancelButtonText: 'Cancelar',
    continueButtonText: 'Salir sin guardar'
  });
  }

}
